export const protocol_questions = {
  edit: {
    history: {
      title: "Protocol changes history",
      changed_by: "Changed by",
      changed_at: "Changed at",
    },
    viewing_local_changes: "You are viewing local changes.",
    viewing_live_version: "You are viewing the live version.",
    clear_local_changes: "Clear local changes",
    other_protocol_questions_linked_to_the_requirement: "Other protocol questions linked to this requirement",
    no_other_protocol_questions_linked_to_the_requirement: "No other protocol questions are linked to this requirement",
    interlink_questions: "Interlink questions",
    save_links: "Save links",
  },
  back_to_protocol_question_edit: "Back to protocol question edit",
  link: {
    protocol_questions: {
      disabled_link_reason: "You need to select at least one protocol question to link.",
      page_title: "Link Related Protocol Questions",
      page_description:
        "Connect related Protocol Questions to enable data sharing between them during assessments. Linked questions allow you to copy responses from one question to another.",
      linked_items_title: "This protocol question is already linked to:",
    },
    requirements: {
      page_title: "Here you can select and link requirements to this protocol question.",
      page_description: "Link requirements to Protocol Question",
    },
  },
} as const;
